module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Hautemorges_COA-7f999f23cfd5771d732fc61852af33ee.svg";